<div class="companies-list-container">
  <div class="filters">
    <div class="search-filter-group">
      <!-- Filter Button -->
      <div class="filter-button-group">
        <button
          class="action-btn secondary-btn"
          [class.activeFilter]="getFiltersCount() > 0"
          (click)="openFilter()"
        >
          <div class="icon">
            <app-svg-icon svgIcon="filter-cc"></app-svg-icon>
          </div>
          <span>{{ 'common.filter' | translate }}</span>
          <div class="clear-icon-container">
            <img
              class="clear-icon"
              *ngIf="getFiltersCount() > 0"
              (click)="clearFilter(); $event.stopPropagation()"
              src="assets/icones/clear-icon.svg"
              alt=""
            />
            <div class="clear-tooltip" *ngIf="getFiltersCount() > 0">
              {{ 'common.clear_filters' | translate }}
            </div>
          </div>
        </button>
      </div>
      <!-- Search Box -->
      <div class="standard-input has-icon search-box">
        <div class="input-container">
          <input
            type="text"
            placeholder="{{ 'agent.portfolio.search' | translate }}"
            [formControl]="searchInput"
            data-testid="search-input"
          />
          <div class="btn-icon" style="cursor: default;">
            <img src="assets/icones/search_icon.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="companies-list-content">
    <table class="companies-table">
      <thead>
        <tr class="row header" [class.audience-row]="source == 'catalogs'">
          <th>
            <mat-checkbox
              [checked]="isAllLocationsSelected()"
              [indeterminate]="isPartialSelectedAll()"
              (change)="toggleAllLocations($event.checked)"
              data-testid="select-all-checkbox"
            >
            </mat-checkbox>
            {{ 'agent.portfolio.company' | translate }}
          </th>
          <th>
            {{ 'agent.portfolio.locations' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <cdk-virtual-scroll-viewport
          itemSize="50"
          class="companies-viewport"
          [class.companies-viewport-catalogs]="source == 'catalogs'"
          (scroll)="onScroll($event)"
        >
          <ng-container *cdkVirtualFor="let company of filteredCompanies; trackBy: trackByCompany">
            <!-- Company row -->
            <tr
              class="row"
              [class.audience-row]="source == 'catalogs'"
              [attr.data-testid]="'company-row-' + company.id"
            >
              <td style="min-width: 0">
                <mat-checkbox
                  [checked]="isCompanyFullySelected(company.id)"
                  [indeterminate]="isCompanyPartiallySelected(company.id)"
                  (change)="toggleCompanyLocations(company.id, $event.checked)"
                  [attr.data-testid]="'company-checkbox-' + company.id"
                ></mat-checkbox>
                <span class="truncate" [title]="company.name">
                  {{ company.name }}
                </span>
              </td>
              <td [ngClass]="{'last-column': source != 'catalogs'}">
                <span>
                  {{ company.locations?.length }}
                </span>
                <img
                  src="assets/icones/arrow.svg"
                  alt=""
                  class="arrow-icon"
                  [class.rotated]="!isCompanyExpanded(company)"
                  (click)="toggleCompanyExpand(company)"
                  [attr.data-testid]="'expand-icon-' + company.id"
                />
              </td>

            </tr>
            <!-- Location rows -->
            <tr
              [class.audience-row]="source == 'catalogs'"
              class="row secondary-row"
              *ngFor="let location of company.locations; trackBy: trackByLocation"
              [class.expanded]="isCompanyExpanded(company)"
              [attr.data-testid]="'location-row-' + location.id"
            >
              <td style="min-width: 0">
                <mat-checkbox
                  [checked]="isLocationSelected(location.id)"
                  (change)="toggleLocation(location.id!, $event.checked)"
                  [attr.data-testid]="'location-checkbox-' + location.id"
                >
                </mat-checkbox>
                <img src="assets/icones/include_icon.svg" alt="" />
                <div style="display: flex; flex-direction: column">
                  <span class="truncate" style="width: 300px">{{ location.name }}</span>
                  <span style="width: 400px" class="secondary-text truncate">{{ location.apartment }}</span>
                </div>
              </td>
              <td>
                <span *ngIf="location.is_main" style="padding-left: 5px" class="tag">
                  {{ 'agent.portfolio.location.main' | translate }}
                </span>
              </td>
            </tr>
          </ng-container>
          <!-- Loading indicator when fetching more companies -->
          <div *ngIf="isLoadingMore">
            <app-loader></app-loader>
          </div>
          <ng-container *ngIf="!filteredCompanies.length && !isLoadingMore">
            <div
              style="height: 200px; display: flex; align-items: center; justify-content: center;"
              class="secondary-text"
            >
              {{ 'agent.portfolio.no_data' | translate }}
            </div>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>
